import { groupLimits } from './accounts/groupLimits';
import { manageGroup } from './accounts/manageGroups';
import { management } from './accounts/management';
import { multiBankAccounts } from './accounts/multibankAccounts';
import { accountOverview } from './accounts/overview';
import { transactionHistory } from './accounts/transactionHistory';
import { viewNavigation } from './accounts/viewNavigation';
import {
    closeVirtualAccounts,
    createVirtualAcc, customRoutingRules, editVirtualAccHierar, massCreation, overviewAndEnablmnt, reportingStatements,
    suspenseAccTrans, virtualAccountEntitlemnts, virtualAccPaymnts, virtualGroupIntrstsLmts
} from './accounts/virtualAccounts';
import { administrators, businessPartnerInformation, exportPreferences, summary, workflow } from "./Admin";
import { appendixScreenResolution } from './appendices/1-screenResolutionCompatibility';
import { appendixCurrencyCutoffTime } from './appendices/2-currencyCutoffTime';
import { appendixMandatoryCountryInfo } from './appendices/3-mandatoryCountryInfo';
import { supportedCurrentAndDepositAccountCurrencies } from './appendices/4-supportedCurrentAndDepositAccountCurrencies';
import { purposeCodes } from './appendices/5-purposeCode';
import { approvalNote, findapprovalitems, pendingApprovals } from "./approvals";
import { bulkUserCreation } from './BulkUserCreation';
import { createIndividualUser, createMultipleUser } from "./CreateUserData";
import { bacsPayments, bacsPaymentsSDSC, chapsPayments, fasterPayments, fasterPaymentsSDSC, guidance, interGroupTransfers, internationalPayments, multipleBacsPayments, multipleFasterPayments, sepaCreditTransfer, template } from './fileImports';
import { accountValidationAsStandardUser, alreadySetUp, loginToLBGConnect, loginToLBGConnectFirstTimePA, logOut, primarySecondaryAccountActivate, siteTimeOut } from "./GettingStarted";
import { glossaryData } from "./glossary";
import { manageActivateUser, manageEditUser, manageResetActCode, manageResetPassword, manageResetPIN, manageSearchUser, manageSecurityCards, manageSecurityDevice, manageSecuritySettings, manageSuspendReactivateUser, manageUnlockUser, manageUserData } from "./ManageUserData";
import { paymentWorkflowAndApproval } from './payments/1-paymentWorkflowAndApproval';
import { paymentMakeInternationalPymt } from './payments/10-makeInternationalPymt';
import { paymentSepaCreditTransfer } from './payments/11-SEPACreditTransfer';
import { sepaDirectDebit } from './payments/12-sepaDirectDebit';
import { paymentReqForTransfer } from './payments/13-requestForTransfer';
import { paymentFItoFI } from './payments/14-FItoFITransfer';
import { interAccounts } from './payments/15-interAccountTransfer';
import { paymentSummary } from './payments/16-paymentSummary';
import { paymentApproval } from './payments/17-paymentApprovals';
import { paymentPreferences } from './payments/18-paymentPreferences';
import { transactionUpload } from './payments/19-transactionUploads';
import { paymentApprovalGroups } from './payments/2-paymentApprovalGroups';
import { paymentsTemplate } from './payments/20-paymentsTemplate';
import { ultimateDebator } from './payments/21-ultimateDebator';
import { recurringPayments } from './payments/22-recurringPayments';
import { paymentManageBeneficiaries } from './payments/3-manageBeneficiaries';
import { paymentBeneficiaryUserGroups } from './payments/4-beneficiaryUserGroups';
import { paymentBankLookUp } from './payments/5-bankLookUp';
import { fasterPayment } from './payments/6-fasterPayments';
import { bacsPayment } from './payments/7-bacsPayments';
import { chaps } from './payments/8-chapsPayment';
import { paymentMainSection } from './payments/paymentHead';
import { auditReports, downloadLegalReporting, informationReports, intradayStatement, reports } from "./reports";
import { systemUserData } from "./SystemUserData";
import { addProfile, cloneProfile, deleteProfile, editProfile, listUsers, userRoleProfileData, viewProfile } from "./UserRoleProfileData";


export const helpData: any = {
    "1": {
        "1": {
            preContent: alreadySetUp,
        },
        "2": {
            preContent: primarySecondaryAccountActivate,

        },
        "3": {
            preContent: accountValidationAsStandardUser,

        },
        "4": {
            "1": {
                preContent: loginToLBGConnect,
            },
            "2": {
                preContent: loginToLBGConnectFirstTimePA,
            },

        },
        "5": {
            "1": {
                preContent: logOut,
            },
            "2": {
                preContent: siteTimeOut,
            },

        },
    },
    "2": {
        "1": {
            postContent: userRoleProfileData,
            "1": {
                postContent: addProfile
            },
            "2": {
                "1": {
                    postContent: editProfile
                },
                "2": {
                    postContent: deleteProfile
                },
                "3": {
                    postContent: viewProfile
                },
                "4": {
                    postContent: cloneProfile
                },
                "5": {
                    postContent: listUsers
                }
            }
        },
        "2": {
            "1": {
                preContent: createIndividualUser,
            },
            "2": {
                preContent: createMultipleUser,
            },

        },
        "3": {
            postContent: manageUserData,
            "1": {
                postContent: manageSearchUser
            },
            "2": {
                postContent: manageEditUser
            },
            "3": {
                postContent: manageActivateUser
            },
            "4": {
                postContent: manageSuspendReactivateUser
            },
            "5": {
                postContent: manageSecuritySettings,
                "1": {
                    postContent: manageResetPIN
                },
                "2": {
                    postContent: manageUnlockUser
                },
                "3": {
                    postContent: manageResetPassword
                },
                "4": {
                    postContent: manageResetActCode
                },
                "5": {
                    postContent: manageSecurityCards
                }
            },
            "6": {
                postContent: manageSecurityDevice
            }
        },
        "4": {
            postContent: systemUserData
        }
    },
    "3": {
        "1": {
            preContent: accountOverview
        },
        "2": {
            preContent: multiBankAccounts
        },
        "3": {
            "1": {
                preContent: overviewAndEnablmnt
            },
            "2": {
                preContent: virtualAccountEntitlemnts
            },
            "3": {
                preContent: createVirtualAcc
            },
            "4": {
                preContent: massCreation
            },
            "5": {
                preContent: editVirtualAccHierar
            },
            "6": {
                preContent: virtualAccPaymnts
            },
            "7": {
                preContent: customRoutingRules
            },
            "8": {
                preContent: suspenseAccTrans
            },
            "9": {
                preContent: reportingStatements
            },
            "10": {
                preContent: virtualGroupIntrstsLmts
            },
            "11": {
                preContent: closeVirtualAccounts
            }

        },
        "4": {
            preContent: viewNavigation
        },
        "5": {
            preContent: management
        },
        "6": {
            preContent: manageGroup
        },
        "7": {
            preContent: transactionHistory
        },
        "8": {
            preContent: groupLimits
        }
    },
    "4": {
        preContent: paymentMainSection,
        "1": {
            preContent: paymentWorkflowAndApproval
        },
        "2": {
            preContent: paymentApprovalGroups
        },
        "3": {
            preContent: paymentManageBeneficiaries
        },
        "4": {
            preContent: paymentBeneficiaryUserGroups
        },
        "5": {
            preContent: paymentBankLookUp
        },
        "6": {
            preContent: fasterPayment
        },
        "7": {
            preContent: bacsPayment
        },
        "8": {
            preContent: chaps
        },
        "10": {
            preContent: paymentMakeInternationalPymt
        },

        "11": {
            preContent: paymentSepaCreditTransfer
        },
        "12": {
            preContent: sepaDirectDebit
        },

        "13": {
            preContent: paymentReqForTransfer
        },
        "14": {
            preContent: paymentFItoFI
        },

        "15": {
            preContent: interAccounts
        },
        "16": {
            preContent: paymentSummary
        },
        "17": {
            preContent: paymentApproval
        },
        "18": {
            preContent: paymentPreferences
        },

        "19": {
            preContent: transactionUpload
        },
        "20": {
            preContent: paymentsTemplate
        },

        "21": {
            preContent: ultimateDebator
        },
        "22": {
            preContent: recurringPayments
        }
    },
    "5": {

        "1": {
            preContent: summary
        },
        "2": {
            preContent: administrators
        },
        "3": {
            preContent: businessPartnerInformation
        },
        "4": {
            preContent: workflow
        },
        "5": {
            preContent: exportPreferences
        },

    },

    "7": {
        preContent: approvalNote,
        "1": {
            preContent: pendingApprovals
        },
        "2": {
            preContent: findapprovalitems
        }


    },
    "8": {
        postContent: reports,
        "1": {
            preContent: informationReports
        },
        "2": {
            preContent: downloadLegalReporting
        },
        "3": {
            preContent: intradayStatement
        },
        "4": {
            preContent: auditReports
        },

    },
    "9": {
        "1": {
            preContent: appendixScreenResolution
        },
        "2": {
            preContent: glossaryData
        },
        "3": {
            preContent: appendixCurrencyCutoffTime
        },
        "4": {
            preContent: appendixMandatoryCountryInfo
        },
        "5": {
            preContent: supportedCurrentAndDepositAccountCurrencies
        },
        "6": {
                "1": {
                    "1": {
                        preContent: guidance
                    },
                    "2": {
                        "1": {
                            preContent: bacsPayments
                        },
                        "2": {
                            preContent: fasterPayments
                        },
                        "3": {
                            preContent: chapsPayments
                        },
                        "4": {
                            preContent: sepaCreditTransfer
                        },
                        "5": {
                            preContent: internationalPayments
                        },
                        "6": {
                            preContent: interGroupTransfers
                        },
                    },
                    "3": {
                        "1": {
                            preContent: bacsPaymentsSDSC
                        },
                        "2": {
                            preContent: multipleBacsPayments
                        },
                        "3": {
                            preContent: fasterPaymentsSDSC
                        },
                        "4": {
                            preContent: multipleFasterPayments
                        },
                        "5": {
                            preContent: chapsPayments
                        },
                        "6": {
                            preContent: sepaCreditTransfer
                        },
                        "7": {
                            preContent: internationalPayments
                        },
                        "8": {
                            preContent: interGroupTransfers
                        },
                    },
                    "4": {
                        "1": {
                            preContent: bacsPayments
                        },
                        "2": {
                            preContent: fasterPayments
                        },
                        "3": {
                            preContent: chapsPayments
                        },
                        "4": {
                            preContent: sepaCreditTransfer
                        },
                        "5": {
                            preContent: internationalPayments
                        },
                        "6": {
                            preContent: interGroupTransfers
                        },
                    },
                    "5": {
                        "1": {
                            preContent: bacsPaymentsSDSC
                        },
                        "2": {
                            preContent: multipleBacsPayments
                        },
                        "3": {
                            preContent: fasterPaymentsSDSC
                        },
                        "4": {
                            preContent: multipleFasterPayments
                        },
                        "5": {
                            preContent: chapsPayments
                        },
                        "6": {
                            preContent: sepaCreditTransfer
                        },
                        "7": {
                            preContent: internationalPayments
                        },
                        "8": {
                            preContent: interGroupTransfers
                        },
                    },                    
                },
                "2": {
                    "1": {
                        preContent: guidance
                    },
                    "2": {
                        preContent: template
                    },                   
                },               
                "3": {
                    "1": {
                        preContent: guidance
                    },
                    "2": {
                        preContent: template
                    },                   
                },            
                "4": {
                    "1": {
                        preContent: guidance
                    },
                    "2": {
                        preContent: template
                    },                   
                },            
                "5": {
                    "1": {
                        preContent: guidance
                    },
                    "2": {
                        preContent: template
                    },                   
                },            
                "6": {
                    preContent: bulkUserCreation             
                },            
         },
         "7": {
            preContent: purposeCodes
        },
    },
}


// WEBPACK FOOTER //
// ./src/components/content/HelpData.ts